<template>
  <div
    class="rounded-md p-4"
    :class="{
      'bg-red-50': type === 'error',
      'bg-blue-50': type === 'info',
      'bg-yellow-50': type === 'warning',
      'bg-green-50': type === 'success',
    }"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <component 
          :is="iconComponent" 
          class="h-5 w-5"
          :class="{
            'text-red-400': type === 'error',
            'text-blue-400': type === 'info',
            'text-yellow-400': type === 'warning',
            'text-green-400': type === 'success',
          }"
          aria-hidden="true" 
        />
      </div>
      <div class="ml-3">
        <h3
          v-if="title"
          class="text-sm mb-2 font-medium"
          :class="{
            'text-red-800': type === 'error',
            'text-blue-800': type === 'info',
            'text-yellow-800': type === 'warning',
            'text-green-800': type === 'success',
          }"
          v-text="title"
        />
        <div
          class="text-sm"
          :class="{
            'text-red-700': type === 'error',
            'text-blue-700': type === 'info',
            'text-yellow-700': type === 'warning',
            'text-green-700': type === 'success',
          }"
          v-html="message"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  XCircleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/vue/24/solid';

const props = defineProps<{
  title?: string,
  message: string,
  type?: string
}>();

const iconComponent = computed(() => {
  switch (props.type) {
  case 'success':
    return CheckCircleIcon;
  case 'info':
    return InformationCircleIcon;
  case 'warning':
    return ExclamationTriangleIcon;
  case 'error':
  default:
    return XCircleIcon;
  }
});
</script>
